import React from 'react';
import LiveSportsNav from '../../Sports/SportsNav/LiveSports';

import styles from './Layout.module.scss';

const LiveLayout = ({ children }) => {
    return (
        <div className={styles.liveLayout}>
            <div className={styles.layoutInnerWrapper}>
                <div className={styles.liveContent}>
                    <LiveSportsNav />
                    {children}
                </div>
            </div>
        </div>
    );
};

export default LiveLayout;
